import type { MetricsInfo } from 'owa-calendar-compose-types';
import type { ComposeFormType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import shouldShowTimeSuggestions from 'owa-calendar-compose-form-store/lib/selectors/shouldShowTimeSuggestions';
import { TimeChangeActionType } from 'owa-calendar-helpers-types';
import {
    getTimeSuggestionsRequestState,
    getLastFindMeetingTimesRequestDate,
    getLastFindMeetingTimesRequestId,
} from 'owa-calendar-time-suggestions';
import { OwaDate, differenceInMinutes } from 'owa-datetime';
import reinforcementLearningRewardsEndpointService from 'owa-calendar-scheduling-service/lib/services/reinforcementLearningRewardsEndpointService';
import getReinforcementLearningRewardsEndpointRequest from 'owa-calendar-scheduling-service/lib/utils/getReinforcementLearningRewardsEndpointRequest';
import sessionStore from 'owa-session-store/lib/store/store';

export default async function sendReinforcementLearningRewardsForTimeSuggestions(
    openedForm: ComposeFormType,
    eventStartTime: OwaDate,
    metricsInfo: MetricsInfo
) {
    if (
        shouldShowTimeSuggestions() &&
        metricsInfo.timeSuggestionStartLastSet &&
        metricsInfo.timeSuggestionStartLastSet.length > 0 &&
        getTimeSuggestionsRequestState()
    ) {
        /* Reward will be set to 1 if and only if the first time suggestion was selected.  Otherwise, reward should be zero */
        let reward: number = 0;
        if (differenceInMinutes(metricsInfo.timeSuggestionStartLastSet[0], eventStartTime) == 0) {
            reward = 1;
        }

        /* isTimeSuggestionClicked is true when the last time changed action came from time suggestions */
        const isTimeSuggestionClicked: boolean =
            metricsInfo.changeTimeActions != null &&
            metricsInfo.changeTimeActions.length > 0 &&
            metricsInfo.changeTimeActions[metricsInfo.changeTimeActions.length - 1] ===
                TimeChangeActionType.TimeSuggestions;

        const scenarioName: string =
            openedForm === 'FullCompose'
                ? 'TimeSuggestionsInFullCompose'
                : 'TimeSuggestionsInQuickCompose';

        const extraFeatures: { [key: string]: string } = {
            IsTimeSuggestionClicked: isTimeSuggestionClicked.toString(),
            AppName: 'OWA',
            UserId: sessionStore.userConfiguration.SessionSettings.ExternalDirectoryUserGuid,
            TenantId: sessionStore.userConfiguration.SessionSettings.ExternalDirectoryTenantGuid,
            // There's only one scenario where both quickComposeEntrySource and fullComposeEntrySource
            // are defined at the same time and that is when the form is opened in QuickCompose and then
            // manually transitioned to FullCompose. In that case fullComposeEntrySource will be equal to
            // "QuickCompose" and quickComposeEntrySource will have the actual entry source we are
            // interested in.
            EntrySource: metricsInfo.quickComposeEntrySource ?? metricsInfo.fullComposeEntrySource,
        };

        const datetime: Date = getLastFindMeetingTimesRequestDate();
        const timestamp: string = datetime ? datetime.toISOString() : '';

        let request = getReinforcementLearningRewardsEndpointRequest(
            scenarioName,
            timestamp,
            getLastFindMeetingTimesRequestId(),
            reward.toString(),
            extraFeatures
        );

        await reinforcementLearningRewardsEndpointService(
            request,
            '75DEF8AC-4AAD-447D-906F-5213991F8057' /* Time Suggestions scenario id, as registered in the RL endpoint */,
            sessionStore.userConfiguration.SessionSettings.ExternalDirectoryUserGuid,
            sessionStore.userConfiguration.SessionSettings.ExternalDirectoryTenantGuid
        );
    }
}
